// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__akH3E","link":"page_link__SHFAd","inlineWrapper":"page_inlineWrapper__5kPMJ"};